<div class="nofound-bg-img d-flex align-items-center justify-content-center" [ngStyle]="{backgroundImage:'url(assets/images/404-banner-image.png)'}">
    <div class="text-center">
        <div class="d-flex align-items-center justify-content-center">
            <img src="assets/images/404-not-icon.png" alt="404-not-icon" class="img-fluid nofound-icon">
            <h3 class="text-white mb-0">404</h3>
        </div>
        <p class="text-white">Sorry, the page you were looking for can not be found.</p>
        <button type="submit" class="btn btn-primary mt-2 home-cta" routerLink="/">Go to Homepage</button>
    </div>
</div>
